import { useEffect, useState } from 'react';
import * as api from '../schedulerApi';
import { Button, Field } from './Shared';

export default function PagedRecords({ path, params = {}, pendingFilter = false, refreshKey, children }) {
 const [status,setStatus]=useState(pendingFilter?'pending':'all');
 const [offset,setOffset]=useState(0),[page,setPage]=useState(null),[error,setError]=useState(''),[retry,setRetry]=useState(0);
 const query=JSON.stringify(params);
 useEffect(()=>{
  let live=true;setPage(null);setError('');
  api.get(path,{...JSON.parse(query),page_size:50,offset,...(pendingFilter?{status}:{})}).then(result=>{
   if(!live)return;
   const next=Array.isArray(result)?{results:result,count:result.length,next_offset:null}:result;
   if(offset>0&&offset>=next.count){setOffset(0);return;}
   setPage(next);
  }).catch(e=>{if(live)setError(api.errorText(e));});
  return()=>{live=false;};
 },[path,query,status,offset,pendingFilter,retry,refreshKey]);
 return <>
  {pendingFilter&&<Field label="Show requests"><select className="select" value={status} onChange={e=>{setStatus(e.target.value);setOffset(0);}}><option value="pending">Pending requests</option><option value="all">All requests</option></select></Field>}
  {error?<div role="alert" className="error-message">{error} <Button variant="secondary small" onClick={()=>setRetry(v=>v+1)}>Retry</Button></div>:!page?<p role="status">Loading records…</p>:<>
   <div className="actions gap-top"><p className="caption" role="status">{page.count?`${offset+1}–${Math.min(offset+50,page.count)} of ${page.count}`:'No matching records.'}</p>{page.count>0&&<><Button variant="secondary small" disabled={offset===0} onClick={()=>setOffset(Math.max(0,offset-50))}>Previous page</Button><Button variant="secondary small" disabled={page.next_offset==null} onClick={()=>setOffset(page.next_offset)}>Next page</Button></>}</div>
   {children(page.results)}
  </>}
 </>;
}
